(() => {
  const sync = () => {
    document.querySelectorAll('[data-stackly-qb]').forEach(root => {
      const unit = Number(root.dataset.unitPrice);
      if (!Number.isSafeInteger(unit) || unit < 0 || root.dataset.currency !== '£') return;
      const money = cents => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
      root.querySelectorAll('.stackly-qb__option').forEach(option => {
        const quantity = Number(option.dataset.qty);
        const percentage = Number(option.dataset.pct);
        const price = option.querySelector('.stackly-qb__price');
        if (!price || !Number.isSafeInteger(quantity) || quantity < 1 || !Number.isFinite(percentage) || percentage < 0 || percentage > 100) return;
        const full = unit * quantity;
        const discounted = (unit - Math.floor(unit * percentage / 100 + 1e-9)) * quantity;
        if (!percentage) {
          price.textContent = money(full);
          return;
        }
        const compare = document.createElement('span');
        compare.className = 'stackly-qb__compare';
        compare.textContent = money(full);
        price.replaceChildren(compare, document.createTextNode(money(discounted)));
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
  document.addEventListener('shopify:section:load', sync);
})();
